export type LabelPropsInput = {
    /**
     * The ID of the heading element that labels the card.
     */
    headingId: string | null;
    /**
     * The ID of the description element that describes the card.
     */
    descriptionId: string | null;

    'aria-labelledby'?: string | undefined;
    'aria-describedby'?: string | undefined;
    'aria-label'?: string | undefined;
};

/**
 * Get the props for a label element.
 */
export function useLabelProps(props: LabelPropsInput): {
    'aria-labelledby'?: string | undefined;
    'aria-describedby'?: string | undefined;
    'aria-label'?: string | undefined;
} {
    return {
        'aria-labelledby':
            props['aria-labelledby'] ||
            (props['aria-label'] ? undefined : props.headingId) ||
            undefined,
        'aria-describedby': props['aria-describedby'] || props.descriptionId || undefined,
        'aria-label': props['aria-label'],
    };
}
